
/**
 * Send invite emails to multiple recipients
 * @param {string[]} emails - Array of email addresses
 * @returns {Promise<object>} Response object with success and data
 */
export async function sendInviteEmails(emails) {
	const formData = new FormData();
	formData.append('action', 'ambassador_invite_via_email');
	formData.append('nonce', wpcore.nonce);

	emails.forEach((email) => {
		formData.append('emails[]', email);
	});

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const json = await response.json();

	if (json.success) {
		return { success: true, message: json.data.message, sent_count: json.data.sent_count };
	}

	return { success: false, message: json.data?.message || wpcore.direct_t({ en: 'Failed to send invitations.', fr: 'Échec de l\'envoi des invitations.' }) };
}
